// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Autoplay, Pagination } from 'swiper/modules';
// Import Swiper styles and required modules
import 'swiper/css';
import 'swiper/css/autoplay';

// Dummy data for the slider
const sliderData = [
  { 
    id: 1, 
    imageUrl: '/images/slider/1.jpg',
    title: 'En yeni teknoloji ve ürünlerle, kalite ve müşteri memnuniyeti odaklı hizmet sunuyoruz.',
    // description: '------------------------------------------------------------'
  },
  { 
    id: 2, 
    imageUrl: '/images/slider/1.jpg',
    title: 'En yeni teknoloji ve ürünlerle, kalite ve müşteri memnuniyeti odaklı hizmet sunuyoruz.',
    // description: '------------------------------------------------------------'
  },
  // { 
  //   id: 3, 
  //   imageUrl: '/images/slider/1.jpg',
  //   title: 'Slide 3 Title',
  //   description: '------------------------------------------------------------'
  // }
];

const Slider = () => {
  const swiperRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0); // track the current slide index

  return (
    <div className='w-full relative h-[60vh]'>
      <Swiper
        slidesPerView={1}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)} // update slide index on change
        autoplay={{
          delay: 3000, // 3 seconds delay
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className='h-full'
      >
        {sliderData.map((slide, index) => (
          <SwiperSlide key={slide.id} className='h-full '>
            <div className='relative flex items-center justify-center h-full'>
              <img src={slide.imageUrl} className='h-full w-full object-cover' alt={`Slide ${slide.id}`} />
              <div className='h-full w-full absolute top-0 left-0 grid grid-cols-10 pb-20'>
                <motion.div 
                  className='min-h-[65%] w-full md:w-1/2 col-start-2 col-span-8 content-center space-y-5'
                  key={currentSlide} // key to force re-render the motion.div when the slide changes
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, ease: "easeOut" }}
                >
                  {/* Dynamically rendering title and description from sliderData */}
                  <motion.h1 
                    className='text-4xl lg:text-5xl text-turkuaz-blue'
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.2 }}
                  >
                    {slide.title}
                  </motion.h1>
                  <motion.p 
                    className='text-lg text-turkuaz-blue'
                    initial={{ opacity: 0, x: 100 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.4 }}
                  >
                    {slide.description}
                  </motion.p>
                </motion.div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className='absolute pl-[10%] bottom-0 z-50 flex items-center space-x-4 h-[20%]'>
        <div className='col-start-2 col-span-8 space-y-5'>
          <img
            src='/images/left.svg'
            className='cursor-pointer hover:translate-x-2 transition-all duration-300 w-10 md:w-auto'
            alt='Previous'
            onClick={() => swiperRef.current?.slidePrev()} // Move to previous slide
          />
          <img
            src='/images/right.svg'
            className='cursor-pointer hover:-translate-x-2 transition-all duration-300 w-10 md:w-auto'
            alt='Next'
            onClick={() => swiperRef.current?.slideNext()} // Move to next slide
          />
        </div>
      </div>
    </div>
  );
};

export default Slider;
